export const FIELDS_HOTSPOTS = [
    { value: "all", label: "all" },
    { value: "ocean", label: "ocean" },
    { value: "lakes", label: "lakes" },
    { value: "drying", label: "drying" },
    { value: "deforestation", label: "deforestation" },
    { value: "forest fire", label: "forest fire" },
    { value: "intensive farming", label: "intensive farming" },
    { value: "military", label: "military" },
    { value: "air", label: "air" },
    { value: "climate", label: "climate" },
    { value: "rivers", label: "rivers" },
    { value: "waste", label: "waste" },
    { value: "poaching", label: "poaching" },
    { value: "acid rains", label: "acid rains" },
    { value: "plastic pollution", label: "plastic pollution" },
    { value: "oil", label: "oil" },
    { value: "mines", label: "mines" },
    { value: "nuclear issues", label: "nuclear issues" },
    { value: "chemical pollution", label: "chemical pollution" },
    { value: "toxic waste", label: "toxic waste" },
    { value: "water conservation", label: "water conservation" },
    { value: "sewage", label: "sewage" },
    { value: "sea level rise", label: "sea level rise" },
    { value: "coral reefs", label: "coral reefs" },
    { value: "biodiversity", label: "biodiversity" },
    { value: "land subsidence", label: "land subsidence" },
    { value: "floods", label: "floods" }

]